var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSupportAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49998 18.5335V9.36687C5.49998 7.90818 6.07944 6.50923 7.11089 5.47778C8.14234 4.44633 9.54129 3.86687 11 3.86687C12.4587 3.86687 13.8576 4.44633 14.8891 5.47778C15.9205 6.50923 16.5 7.90818 16.5 9.36687V18.5335M1.83331 12.6348C1.83331 10.7529 3.66665 10.2835 5.49998 10.2835V18.5335C4.52752 18.5335 3.59489 18.1472 2.90725 17.4596C2.21962 16.772 1.83331 15.8393 1.83331 14.8669V12.6348ZM20.1666 12.6348C20.1666 10.7529 18.3333 10.2835 16.5 10.2835V18.5335C17.4724 18.5335 18.4051 18.1472 19.0927 17.4596C19.7803 16.772 20.1666 15.8393 20.1666 14.8669V12.6348Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupportAdmin);
export default __webpack_public_path__ + "static/media/icon-support-admin.fcd580cc5c0004bb386eefe69dbd117b.svg";
export { ForwardRef as ReactComponent };